import { ArrowForward, Article } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { M_Fieldset } from "src/M_Components";
import { ShippingConditionFormField } from "./ShippingConditionFormField";

export const ShippingConditionInfo = ({ dataState, setDataState }) => {
  const { t } = useTranslation()

  return (
    <>
      <M_Fieldset
        labelInside
        label={
          <div
            style={{
              display: "flex",
              alignItems: "center",
              fontSize: "25px",
              marginLeft: "10px",
            }}
          >
            <Article style={{ marginRight: "10px", scale: "1.3" }} />{" "}
            {t("Information")}
          </div>
        }
        elements={
          <div
            style={{
              display: "flex",
              flexWrap: "wrap"
            }}
          >
            <ShippingConditionFormField label={t("Code")} type="text" code="ShippingConditionCode" data={dataState} setData={setDataState} />
            <ShippingConditionFormField label={t("Name")} type="text" code="ShippingConditionName" data={dataState} setData={setDataState} />
          </div>
        }
      />
    </>
  )
}
